import { render, staticRenderFns } from "./NbFooter.vue?vue&type=template&id=30fd9f1b&scoped=true&"
import script from "./NbFooter.vue?vue&type=script&lang=js&"
export * from "./NbFooter.vue?vue&type=script&lang=js&"
import style0 from "./NbFooter.vue?vue&type=style&index=0&id=30fd9f1b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fd9f1b",
  null
  
)

export default component.exports